var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8096 16.0958V9.23861H12.2857V3.90527H17.6191L16.0953 7.7148H17.6191L13.8096 16.0958ZM12.2857 10.7624V16.0958H3.90479C3.0667 16.0958 2.38098 15.41 2.38098 14.5719V12.2862C2.38098 11.4481 3.0667 10.7624 3.90479 10.7624H12.2857ZM5.61908 12.8577H4.47622V14.0005H5.61908V12.8577ZM10.7619 3.90527V9.23861H3.90479C3.0667 9.23861 2.38098 8.55289 2.38098 7.7148V5.42908C2.38098 4.59099 3.0667 3.90527 3.90479 3.90527H10.7619ZM5.61908 6.00051H4.47622V7.14337H5.61908V6.00051Z",
    fill: "#2E87D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmIcon);
export default __webpack_public_path__ + "static/media/vmIcon.0442e11f78485511aa4e858be7f9693b.svg";
export { ForwardRef as ReactComponent };